module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "wrapper-cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "outputType": _vm.option.outputType,
      "info": _vm.option.info,
      "canScale": _vm.option.canScale,
      "autoCrop": _vm.option.autoCrop,
      "autoCropWidth": _vm.option.width,
      "autoCropHeight": _vm.option.height
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-btn"
  }, [_c('label', {
    staticClass: "primary mr10",
    attrs: {
      "for": "uploads"
    }
  }, [_vm._v("upload")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0 0 0 0)"
    },
    attrs: {
      "type": "file",
      "id": "uploads",
      "accept": "image/png, image/jpeg, image/gif, image/jpg"
    },
    on: {
      "change": _vm.uploadImg
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69087b8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/demo/cropper.vue
// module id = 877
// module chunks = 0